// extracted by mini-css-extract-plugin
export default {"container":"nav_group-module__container--1RMut"};